<template>
  <div class="vux-swiper-item"><slot></slot></div>
</template>

<script>
export default {
  created () {
    this.$nextTick(() => {
      this.$parent.rerender()
    })
  },
  beforeDestroy () {
    const $parent = this.$parent
    this.$nextTick(() => {
      $parent.rerender()
    })
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// swiper-item.vue?7a959bac